"use strict";
exports.__esModule = true;
exports.createQueryHook = void 0;
var client_1 = require("../contexts/client");
function createQueryHook(BP) {
    return function useHook(params) {
        var client = (0, client_1.useClient)();
        var query = client.useQuery(BP, params);
        return query;
    };
}
exports.createQueryHook = createQueryHook;
